import {Grid} from '@mui/material';
import AppAnimate from 'main/core/AppAnimate';
import AppGridContainer from 'main/core/AppGridContainer';
import DyeLotAlerts from './DyeLotAlerts';
import inventDashData from './inventDashData';
import ProductQuantity from './ProductQuantity';
import ReadyStock from './ReadyStock';
import StockOverview from './StockOverview';
import Valuation from './Valuation';

const InventDash = () => {
  return (
    <AppAnimate animation='transition.slideUpIn' delay={200}>
      <AppGridContainer>
        <Grid item xs={12} md={7}>
          <Valuation valuationData={inventDashData.valuationData} />
        </Grid>

        <Grid item xs={12} md={5}>
          <ReadyStock readyStockData={inventDashData.readyStockData} />
        </Grid>

        <Grid item xs={12} md={7}>
          <ProductQuantity productData={inventDashData.productData} />
        </Grid>

        <Grid item xs={12} md={5}>
          <StockOverview data={inventDashData.stockStatusData} />
        </Grid>

        <Grid item xs={12} md={12}>
          <DyeLotAlerts dyelotData={inventDashData.dyelotData} />
        </Grid>
      </AppGridContainer>
    </AppAnimate>
  );
};

export default InventDash;
